export default __webpack_public_path__ + "static/media/190629_190332_IMG_4521.de60d32a.jpg";